import { connect } from 'react-redux';

import BuildSelectorComponent from './../Components/BuildSelectorComponent.jsx';
import {
  setBuildInfo,
  modal as modalActions,
  sonar as sonarActions
} from './../actions';
import {
  getBaselineBuildInfo,
  buildsByTypesAndProducts,
  getBuildInfo,
  jobCountsByBuildId
} from './../reducers';
import {
  auth,
  build as buildConstants
} from './../helpers';
import { annotation as annotationSelectors } from './../selectors';

export const mapStateToProps = (state, ownProps) => {
  return {
    isAuthenticated: auth.checkAuthenticated(),
    buildInfo: ownProps.isBaseline ? getBaselineBuildInfo(state) : getBuildInfo(state),
    buildsByTypesAndProducts: buildsByTypesAndProducts(state),
    jobCountsByBuildId: jobCountsByBuildId(state),
    annotationsFeedbackScoresByBuildIds: annotationSelectors.
      getFeedbackScoresByBuildIds(state)
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: buildInfo => {
    dispatch(modalActions.showBuildSelectorModal(false));
    dispatch(setBuildInfo(buildInfo, ownProps.isBaseline));

    // only grabbing Sonar data for Production for now
    if (buildInfo.buildType === buildConstants.BUILD_PRODUCTION ) {
      dispatch(sonarActions.fetchSonarDataByBuilds(buildInfo));
    }
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BuildSelectorComponent);


// WEBPACK FOOTER //
// src/Containers/BuildSelectorContainer.jsx